import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Gateway } from "src/components/shared-components/class/general-classes/gateway";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { GatewayStatus } from "src/components/shared-components/enum/enumGateway";
import { GatewayStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Action fired on start of gateway loading process
 */
export const gatewayLoadStartsAction = createAction(
  GatewayStoreAction.GATEWAY_LOAD_START
);

/**
 * Action fired on gateway load success
 */
export const gatewayLoadSuccessAction = createAction(
  GatewayStoreAction.GATEWAY_LOAD_SUCCESS,
  props<{ gatwayApiData: GenericApiData }>()
);

/**
 * Action to start error handling for gateway list fopulation
 */
export const gatewayLoadErrorHandlingAction = createAction(
  GatewayStoreAction.GATEWAY_LOAD_ERROR_HANDLING,
  props<{ error: HttpErrorResponse }>()
);


/**
 * Action fired on gateway list population with old, pre-existent data (after API error).
 */
export const gatewayLoadWithOldDataAction = createAction(
  GatewayStoreAction.GATEWAY_LOAD_OLD_DATA
);



/**
 * Action fired on gateway load error
 */
export const gatewayLoadErrorAction = createAction(
  GatewayStoreAction.GATEWAY_LOAD_ERROR
);

/**
 * Unset list geateway action
 */
export const gatewayUnsetListAction = createAction(
  GatewayStoreAction.GATEWAY_UNSET_LIST
);

/**
 * Update failed bus operation specific gateway count action
 */
export const gateayUpdateFailedBusOperationAction = createAction(
  GatewayStoreAction.GATEWAY_UPDATE_FAILED_BUS_OPERATION_COUNT,
  props<{ instanceGuid: string; failedBusOperationCount }>()
);

/**
 * Gateway connection status changed action
 */
export const gatewayConnectionStatusChangedAction = createAction(
  GatewayStoreAction.GATEWAY_CONNECTION_STATUS_CHANGED,
  props<{ instanceGuid: string; status: GatewayStatus }>()
);

/**
 * Action fired on start of gateway settings loading process
 */
export const gatewaySettingsLoadStartsAction = createAction(
  GatewayStoreAction.GATEWAY_SETTINGS_LOAD_START
);

/**
 * Action fired on gateway settings load success
 */
export const gatewaySettingsLoadSuccessAction = createAction(
  GatewayStoreAction.GATEWAY_SETTINGS_LOAD_SUCCESS,
  props<{ gatwayApiData: GenericApiData }>()
);

/**
 * Action to start error handling for gateway settings list population
 */
export const gatewaySettingsLoadErrorHandlingAction = createAction(
  GatewayStoreAction.GATEWAY_SETTINGS_LOAD_ERROR_HANDLING,
  props<{ error: HttpErrorResponse }>()
);


/**
 * Action fired on gateway settings list population with old, pre-existent data (after API error).
 */
export const gatewaySettingsLoadWithOldDataAction = createAction(
  GatewayStoreAction.GATEWAY_SETTINGS_LOAD_OLD_DATA
);



/**
 * Action fired on gateway settings load error
 */
export const gatewaySettingsLoadErrorAction = createAction(
  GatewayStoreAction.GATEWAY_SETTINGS_LOAD_ERROR
);

/**
 * Unset list geateway settings action
 */
export const gatewaySettingsUnsetListAction = createAction(
  GatewayStoreAction.GATEWAY_SETTINGS_UNSET_LIST
);
